
export const common = {
  // Navigation
  home: 'الرئيسية',
  jobs: 'فرص العمل',
  candidates: 'المرشحون',
  services: 'الخدمات',
  about: 'حولنا',
  contact: 'اتصل بنا',
  
  // Auth
  login: 'تسجيل الدخول',
  register: 'إنشاء حساب',
  logout: 'تسجيل الخروج',
  
  // Common actions
  search: 'بحث',
  filter: 'تصفية',
  apply: 'تقديم طلب',
  save: 'حفظ',
  cancel: 'إلغاء',
  submit: 'إرسال',
  edit: 'تعديل',
  delete: 'حذف',
  view: 'عرض',
  download: 'تحميل',
  
  // Job related
  fullTime: 'دوام كامل',
  partTime: 'دوام جزئي',
  contract: 'عقد',
  internship: 'تدريب',
  remote: 'عمل عن بعد',
  onSite: 'في الموقع',
  hybrid: 'مختلط',
  salary: 'الراتب',
  experience: 'الخبرة',
  location: 'الموقع',
  company: 'الشركة',
  
  // Time
  hour: 'ساعة',
  hours: 'ساعات',
  day: 'يوم',
  days: 'أيام',
  week: 'أسبوع',
  weeks: 'أسابيع',
  month: 'شهر',
  months: 'أشهر',
  year: 'سنة',
  years: 'سنوات',
  
  // Status
  active: 'نشط',
  inactive: 'غير نشط',
  pending: 'في الانتظار',
  approved: 'موافق عليه',
  rejected: 'مرفوض',
  
  // Messages
  success: 'نجح',
  error: 'خطأ',
  warning: 'تحذير',
  info: 'معلومات',
  loading: 'جاري التحميل...',
  noResults: 'لا توجد نتائج',
  
  // Footer
  allRightsReserved: 'جميع الحقوق محفوظة',
  privacyPolicy: 'سياسة الخصوصية',
  termsOfService: 'شروط الخدمة',
  
  // Hero section
  heroTitle: 'اعثر على وظيفتك المثالية في المجتمع المغاربي في روان',
  heroSubtitle: 'تواصل مع أصحاب العمل المحليين واكتشف فرص العمل المناسبة لملفك الشخصي',
  heroSearchPlaceholder: 'البحث عن وظيفة، شركة...',
  heroLocationPlaceholder: 'المدينة، المنطقة...',
  
  // Services
  cleaning: 'التنظيف',
  homeRepair: 'إصلاح المنزل',
  elderCare: 'رعاية كبار السن',
  petCare: 'رعاية الحيوانات الأليفة',
  childCare: 'رعاية الأطفال',
  mechanics: 'الميكانيكا',
  administrative: 'الإجراءات الإدارية',
  translation: 'الترجمة',
  
  // Administrative services
  administrativeTitle: 'مرافقة الإجراءات الإدارية',
  administrativeSubtitle: 'ترجمة ومساعدة شخصية',
  certifiedTranslation: 'ترجمة معتمدة',
  prefectureServices: 'إجراءات المحافظة',
  bankingServices: 'الإجراءات المصرفية',
  healthServices: 'إجراءات الصحة',
  schoolServices: 'الإجراءات المدرسية',
  housingServices: 'إجراءات السكن',
  
  // Documents
  identityDocuments: 'وثائق الهوية',
  administrativeDocuments: 'الوثائق الإدارية',
  schoolDocuments: 'الوثائق المدرسية',
  medicalDocuments: 'الوثائق الطبية',
  legalDocuments: 'الوثائق القانونية',
  professionalDocuments: 'الوثائق المهنية',
  
  // Stats
  activeJobs: 'الوظائف النشطة',
  registeredCandidates: 'المرشحون المسجلون',
  successfulPlacements: 'التوظيفات الناجحة',
  partnerCompanies: 'الشركات الشريكة'
};
